import { z } from 'zod';
/** Machine codes. The frontend branches on these; it never parses `message`. */
export const ERROR_CODES = {
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    ACCOUNT_INACTIVE: 'ACCOUNT_INACTIVE',
    WRONG_PORTAL: 'WRONG_PORTAL',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    REFRESH_REUSED: 'REFRESH_REUSED',
    ORG_CONTEXT_REQUIRED: 'ORG_CONTEXT_REQUIRED',
    ORG_ACCESS_DENIED: 'ORG_ACCESS_DENIED',
    FEATURE_NOT_ENABLED: 'FEATURE_NOT_ENABLED',
    ROLE_NOT_PERMITTED: 'ROLE_NOT_PERMITTED',
    USAGE_LIMIT_REACHED: 'USAGE_LIMIT_REACHED',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    NOT_FOUND: 'NOT_FOUND',
    DUPLICATE_LEAD: 'DUPLICATE_LEAD',
    LOST_REASON_REQUIRED: 'LOST_REASON_REQUIRED',
    RATE_LIMITED: 'RATE_LIMITED',
    INTERNAL: 'INTERNAL',
};
/** Every list endpoint accepts these. */
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
    sort: z.string().optional(),
    order: z.enum(['asc', 'desc']).default('desc'),
});
export function emptyList(pageSize = 25) {
    return { data: [], page: 1, pageSize, total: 0, hasMore: false };
}
export function buildList(data, total, page, pageSize) {
    return { data, page, pageSize, total, hasMore: page * pageSize < total };
}
//# sourceMappingURL=api.js.map